var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{staticClass:"image-components",class:[_vm.src ? '' : 'none','rate-'+_vm.rate]},[(_vm.src)?_c('img',{staticClass:"image",attrs:{"src":_vm.src,"alt":_vm.alt}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }